<template>
  <div class="container-login">
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="3">
          </v-col>
          <v-col cols="6">
            <v-row>
              <!-- <v-col cols="12"><div style="height: 100px;"></div></v-col> -->
              <v-col cols="12" class="text-center text-4xl font-semibold">
                <font class="">SmartLink </font><font class="light-blue--text">Platform</font>
              </v-col>
              <v-col cols="12"><div style="height: 80px;"></div></v-col>
              <v-col cols="12" class="text-3xl font-semibold blue--text">
                Your Password has been changed!
              </v-col>
              <v-col cols="12" class="text-sm blue--text">
                This email confirms that your password has been changed.<br/>
                To sign in to the SmartLink Platform, use the following credentials:
              </v-col>
              <v-col cols="12" class="text-sm blue--text">
                Account : yongdol74@gmail.com<br/>
                Password : dsifiosajfkslf!
              </v-col>
              <v-col cols="12"><div style="height: 20px;"></div></v-col>
              <v-col cols="12" class="text-xs light-blue--text">
                If the button above does not work, try copying and pasting the <a @click="$router.push('/createaccount')" class="underline">URL</a> into your browser.<br/>
                If you continue to have problems, please left free to contact us at SmartLink Platform@cyberlogitec.com
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3">
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  export default {
    data: () => ({
      userid: '',
      userpwd: '',
    }),

    methods: {
      login() {
      },
    }
  }
</script>